import React from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { ToastContainer } from '../common/Toast';

interface LayoutProps {
  children: React.ReactNode;
  currentSection: string;
  onNavigate: (section: string) => void;
}

export const Layout: React.FC<LayoutProps> = ({ children, currentSection, onNavigate }) => {
  const getSectionTitle = (sectionId: string) => {
    const titles: Record<string, string> = {
      'dashboard': 'Dashboard',
      'products': 'Produtos Imobiliários',
      'templates': 'Templates de Mensagens',
      'database': 'Base de Dados',
      'messages': 'Fila de Mensagens',
      'tasks': 'Task Board',
      'whatsapp': 'Integração WhatsApp'
    };
    return titles[sectionId] || 'Hollos CRM';
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <Sidebar currentSection={currentSection} onNavigate={onNavigate} />
        
        <main className="col-md-9 col-lg-10 main-content">
          <Header title={getSectionTitle(currentSection)} />
          
          <div className="chevron-decoration chevron-left"></div>
          <div className="chevron-decoration chevron-right"></div>
          
          <div className="content-sections">
            {children}
          </div>
        </main>
      </div>
      <ToastContainer />
    </div>
  );
};